// Components==============
import GoogleMapReact from 'google-map-react';
import React from 'react';
import Location from '../Location';
import './index.module.scss';
// =========================
export default function Maps({ schools }) {
    const subDivisions = schools.map((e) => e?.subdivisions).filter((e) => e);
    const filteredSchools = schools.filter((e) => !e?.has_subdivions);

    const defaultProps = {
        center: {
            lat: 51.59,
            lng: 5.4585,
        },
        zoom: 10,
    };

    return (
        <div styleName="wrapper">
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: process.env.MIX_GOOGLE_MAPS_API_KEY,
                }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
            >
                {filteredSchools.map((e) => (
                    <Location
                        lat={e?.contact?.lat}
                        lng={e?.contact?.long}
                        index={e?.index}
                        key={e.name}
                        map
                    />
                ))}
                {subDivisions.map((subDivision) =>
                    subDivision.map((e, i) => (
                        <Location
                            lat={e?.lat}
                            lng={e?.long}
                            index={e?.index}
                            key={e.key}
                            map
                        />
                    ))
                )}
            </GoogleMapReact>
        </div>
    );
}
